import { render, staticRenderFns } from "./VendorBasicInformation.vue?vue&type=template&id=82490dd6&"
import script from "./VendorBasicInformation.vue?vue&type=script&lang=js&"
export * from "./VendorBasicInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports